// Angular
import { NgModule } from '@angular/core';

// Componentes
import { MeAviseListaComponent } from './me-avise/me-avise-lista.component';
import { AtendimentoListaComponent } from './atendimento/atendimento-lista/atendimento-lista.component';
import { MinhaAgendaListaComponent } from './minha-agenda/minha-agenda-lista/minha-agenda-lista.component';
import { MinhaAgendaFormComponent } from './minha-agenda/minha-agenda-form/minha-agenda-form.component';
import { TransferenciaAgendaComponent } from './transferencia-agenda/transferencia-agenda.component';
import { TelefonicaListaComponent } from './telefonica/telefonica-lista/telefonica-lista.component';
import { TelefonicaFormComponent } from './telefonica/telefonica-form/telefonica-form.component';
// import { ExibeErrosComponent } from '@app/components/exibe-erros/exibe-erros.component';

// Roteamento
import { AgendaRoutingModule } from './agenda.routing';

// Guardas
// import { AuthGuard } from '@app/guards/auth.guard';
// Services
import { ConsultasService } from '@app/services/consultas.service';
import { MeAviseService } from '@app/services/meavise.service';
import { ParticipanteService } from '@app/services/participante.service';
import { RelatorioService } from '@app/services/relatorio.service';
import { UsuarioService } from '@app/services/usuario.service';
import { UtilitarioService } from '@app/services/utilitario.service';
import { MinhaAgendaService } from '@app/services/minha-agenda.service';
import { AgendaTelefonicaService } from '@app/services/agenda-telefonica.service';
import { MeAviseTipoService } from '@app/services/me-avise-tipo.service';
import { FuncionarioService } from '@app/services/funcionario.service';

// Terceiros
import { BsModalService } from 'ngx-bootstrap/modal';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { NgxSelectModule, INgxSelectOptions } from 'ngx-select-ex';
import { TextMaskModule } from 'angular2-text-mask';

// Módulos
import { SharedModule } from '../../shared/shared.module';

// CONFIGURAÇÃO MÓDULOS
const CustomSelectOptions: INgxSelectOptions = {
  optionValueField: 'Id',
  optionTextField: 'Descricao',
  placeholder: 'Pesquisar...',
  allowClear: true,
  keepSelectedItems: true,
  noResultsFound: 'Nenhum resultado encontrado'
};
@NgModule({
  imports: [
    AgendaRoutingModule,
    SharedModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory
    }),
    PaginationModule.forRoot(),
    NgxSelectModule.forRoot(CustomSelectOptions),
    TextMaskModule,
  ],
  declarations: [
    MeAviseListaComponent,
    AtendimentoListaComponent,
    MinhaAgendaListaComponent,
    MinhaAgendaFormComponent,
    TransferenciaAgendaComponent,
    TelefonicaListaComponent,
    TelefonicaFormComponent,
    // ExibeErrosComponent,
  ],
  providers: [
    // { provide: HTTP_INTERCEPTORS, useClass: HeaderInterceptor, multi: true },
    // Guards,
    // AuthGuard,
    // Services
    ConsultasService,
    MeAviseService,
    ParticipanteService,
    RelatorioService,
    UtilitarioService,
    UsuarioService,
    MinhaAgendaService,
    BsModalService,
    AgendaTelefonicaService,
    MeAviseTipoService,
    FuncionarioService,
  ],
  exports: [
    AtendimentoListaComponent
  ],
  // schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})

export class AgendaModule { }
